// handlers for work with session storage
export const getSessionStorageItem = <T extends unknown>(key: string): T | null => {
  const storageItem = sessionStorage.getItem(key)

  if (storageItem && storageItem !== 'undefined' && storageItem !== 'null') {
    return JSON.parse(storageItem || '{}') as T
  }

  return null
}

export const setSessionStorageItem = (key: string, value: string | object | null) =>
  sessionStorage.setItem(key, JSON.stringify(value))

// handlers for work with local storage
export const getLocalStorageItem = <T extends unknown>(key: string): T | null => {
  const storageItem = localStorage.getItem(key)

  if (storageItem && storageItem !== 'undefined' && storageItem !== 'null') {
    try {
      return JSON.parse(storageItem || '{}') as T
    } catch (e) {
      return storageItem as T
    }
  }

  return null
}

export const setLocalStorageItem = (key: string, value: string | number | object | null) =>
  localStorage.setItem(key, JSON.stringify(value))
